import { LineString } from "geojson"
import { AcquisitionPlatform } from "./MissionsTypes"

export enum FlightplanStatus {
    Active = "Active",
    Inactive = "Inactive",
    Complete = "Complete",
}

export type FlightplanType = {
    flight_plan_id?: number
    flight_plan_name?: string
    acquisition_platform?: AcquisitionPlatform
    project_number?: string
    status?: FlightplanStatus
    source_file?: string
}

export interface PlannedNode {
    node_name: number
    shape: string
}

export interface FlightPlannedLineBase {
    planned_line_id: number
    flight_line_name: string
    planned_distance: number | null
    mission_name: string | null
    frame_count?: number
    shape?: LineString
    planned_nodes?: PlannedNode[]
}

// being created so no flight_plan_id
export interface FlightPlannedLineType extends FlightPlannedLineBase {
    planned_line_id: number
    flight_line_name: string
    flight_plan_id?: number | null
    planned_distance: number | null
    mission_name: string | null
    shape?: LineString
    planned_nodes?: PlannedNode[]
    /*
     * Front-end only
     * */
    node_count?: number
}

// Exists so has flight_plan_id
export interface CreatedFlightPlannedLine extends FlightPlannedLineBase {
    flight_plan_id: number

    /*
     * Front-end only
     * */
    node_count?: number
}
